import { cn } from '@/lib/utils'

export function HeroTitle({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return <h1 className={cn('hero-title', className)}>{children}</h1>
}
